import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsConsentService {

  private consent = true;

  setConsent(value: boolean) {
    this.consent = value;
  }

  hasConsent(): boolean {
    return this.consent;
  }
}
